(function () {
    'use strict';

    angular
        .module('app')
        .controller('landing', landing);

    landing.$inject = ['$http', '$location', 'sidebarservice', 'favoritesService', 'savedSearchService', '$timeout', '$state', 'gridDataService', '$scope', '$mdDialog', 'ftsService', 'dataCardService', '$filter', 'searchService', 'loginService', 'systemOptionsService', 'fileGuideService', 'commandService', 'clientService'];

    function landing($http, $location, sidebarservice, favoritesService, savedSearchService, $timeout, $state, gridDataService, $scope, $mdDialog, ftsService, dataCardService, $filter, searchService, loginService, systemOptionsService, fileGuideService, commandService, clientService) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'landing';
        vm.favoritesService = favoritesService;
        vm.savedSearchService = savedSearchService;
        favoritesService.animationClass = "";
        savedSearchService.animationClass = "";
        vm.state = $state;
        vm.currentCardId = dataCardService.landingDataCardId;
        vm.favPages = [];
        vm.SAFTerm = "";
        vm.cardDropdownShow = false;
        vm.savedSearchPages = [];
        vm.dataCards = [];
        vm.loginService = loginService;
        vm.systemOptionsService = systemOptionsService;
        vm.clientService = clientService;
        //clear grid data
        gridDataService.data = [];
        //loginService.initStrings().then(function () {
        vm.searchCardLabel = loginService.resourceStrings["SEARCH_CARD"]; // Not working in HTML like: {{vm.loginService.resourceStrings["SEARCH_CARD"]}}
        //    vm.selectADataCardLabel = loginService.resourceStrings["SELECT_A_DATA_CARD"];
        //    vm.actionsLabel = loginService.resourceStrings["ACTIONS"];
        //    vm.uploadLabel = loginService.resourceStrings["UPLOAD"];
        //    vm.searchLabel = loginService.resourceStrings["SEARCH"];
        //    vm.lastSearchLabel = loginService.resourceStrings["LAST_SEARCH"];
        //    vm.favoritesLabel = loginService.resourceStrings["FAVORITES"];
        //    vm.noFavoritesLabel = loginService.resourceStrings["NO_FAVORITES"];
        //    vm.savedSearchesLabel = loginService.resourceStrings["SAVED_SEARCHES"];
        //    vm.noSavedSearches = loginService.resourceStrings["NO_SAVED_SEARCHES"];
        //});

        dataCardService.getAvailableCards().then(function () {
            for (var card in dataCardService.availableDataCards) {
                vm.dataCards.push({ id: card, name: dataCardService.availableDataCards[card] });
            }
            vm.currentCardId = vm.currentCardId.length == 0 ? dataCardService.currentDataCardId : vm.currentCardId;
            vm.currentCardName = $filter('filter')(vm.dataCards, { id: vm.currentCardId })[0].name;
        });

        favoritesService.getDefinitions().then(function () {
            var pages = Math.ceil(parseFloat(favoritesService.definitions.length / 4));
            for (var i = 0; i < pages; i++) {
                vm.favPages.push({ index: i });
            }
            $timeout(function () {
                vm.processing = false;
            }, 500);

        });

        savedSearchService.getDefinitions().then(function () {
            var pages = Math.ceil(parseFloat(savedSearchService.definitions.length / 4));
            for (var i = 0; i < pages; i++) {
                vm.savedSearchPages.push({ index: i });
            }
        });


        vm.showFavorite = function (item) {
            vm.processing = true;
            fileGuideService.clearSelectedNodes();
            favoritesService.currentItem = item;
            gridDataService.serviceIdentifier = "favoritesService";
            gridDataService.processing = true;
            $timeout(function () {
                $state.go('layout.results.grid').then(function () {
                    gridDataService.reloadGrid();
                });
            });

        };

        vm.showSavedSearch = function (item) {
            vm.processing = true;
            fileGuideService.clearSelectedNodes();
            savedSearchService.currentItem = item;
            gridDataService.serviceIdentifier = "savedSearchService";
            gridDataService.processing = true;
            $timeout(function () {
                $state.go('layout.results.grid').then(function () {
                    gridDataService.reloadGrid();
                });
            });
        };

        vm.createNewDocument = function () {
            commandService.launchCommand('newdoc');
        }


        //prevents backspace from navigating to login
        var rx = /INPUT|SELECT|TEXTAREA/i;
        var disableBackspace = function (e) {
            if (e.which == 8) { // 8 == backspace
                if (!rx.test(e.target.tagName) || e.target.disabled || e.target.readOnly) {
                    e.preventDefault();
                }
            }
        }

        //bind keydown event
        $(document).bind("keydown keypress", disableBackspace);

        //unbind the key press to allow backspace navigation outside the landing page
        $scope.$on("$destroy", function () {
            $(document).unbind("keydown keypress", disableBackspace);
        });

        vm.uploadButtonClicked = function () {
            // Check if still logged in.
            loginService.isLoggedIn().then(function (data) {
                $mdDialog.show({
                    controller: uploadDialog,
                    templateUrl: "app/checkin/templates/UploadDialog.html",
                    clickOutsideToClose: false,
                    fullscreen: false,
                    parent: angular.element(document.body)
                });
            }, function (data) {
                //$state.go("login");
            }); // Not logged in.
        }

        var uploadDialog = function (scope) {
            scope.onOK = function () {
                $mdDialog.hide();
            }
            scope.onCancel = function () {
                $mdDialog.cancel();
            }
        }

        //gets the last search item
        vm.getLastSearch = function () {
            fileGuideService.clearSelectedNodes();
            vm.processing = true;
            //set the grid's data service service identifier to be the saved search service
            gridDataService.serviceIdentifier = "lastSearchService";
            //set the totalRecords to 0 which identifies this search as a new search
            gridDataService.totalRecords = 0;
            //display the grid
            //dummy state to make the grid reload

            gridDataService.processing = true;
            $timeout(function () {
                $state.go('layout.results.grid').then(function () {
                    gridDataService.reloadGrid();
                });
            });

        };

        vm.favoritesPages = function () {
        }

        vm.onSearchInputKeyPress = function (event) {
            if (event.keyCode == 13 && vm.SAFTerm.length > 0) {
                vm.searchAllFields();
            }
        }

        vm.searchAllFields = function () {
            searchService.searchCriteria = [{
                "schemaID": '__SEARCH_ALL_FIELDS__',
                "valueStr": vm.SAFTerm,
                "startDate": "",
                "endDate": "",
                "searchOp": "",
                "safCardId": vm.currentCardId,
            }];

            //must identify the service in order to inject the correct one.
            gridDataService.serviceIdentifier = "searchService";
            //reset, since it's a new search
            gridDataService.totalRecords = 0;

            //gridDataService.data = [];

            //go to the grid
            $state.go('layout.results.grid').then(function () {
                gridDataService.reloadGrid();
            });
        }

        vm.toggleCardDropdown = function () {
            vm.cardDropdownShow = !vm.cardDropdownShow;
        }

        vm.dataCardChanged = function (card) {
            vm.currentCardName = card.name;
            vm.currentCardId = card.id;
            dataCardService.landingDataCardId = card.id;
            vm.cardDropdownShow = false;
        }

        vm.processing = true;

    }
})();
